import {otsBaseApi} from "../../ots-api";
import {AllocatableLoad} from "../../../model/allocatable-load";
import {AllocatableLoadSearchCriteria} from "../../../model/search/allocatable-load-search-criteria";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ['AllocatableLoads']})

const allocatableLoadsApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchAllocatableLoads: builder.query<AllocatableLoad[], AllocatableLoadSearchCriteria>({
      query: (arg) => ({
        url: `/allocatable-loads/search`,
        method: "POST",
        body: arg
      }),
      providesTags: (result, _error, arg, _meta) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: 'AllocatableLoads', id} as const)),
            {type: 'AllocatableLoads', id: 'LIST'},
          ];
        } else {
          return [{type: 'AllocatableLoads', id: 'LIST'}];
        }
      },
    }),
    getAllAllocatableLoads: builder.query<AllocatableLoad[], string | undefined>({
      query: (regionId) => ({
        url: `/allocatable-loads/all`,
        method: 'GET',
        params: regionId ? {regionId: regionId} : undefined
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: 'AllocatableLoads', id} as const)),
            {type: 'AllocatableLoads', id: 'LIST'},
          ];
        } else {
          return [{type: 'AllocatableLoads', id: 'LIST'}];
        }
      },
    }),
    getAllocatableLoads: builder.query<AllocatableLoad, string>({
      query: (id) => ({
        url: `/allocatable-loads/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{type: 'AllocatableLoads', id}],
    }),
    createAllocatableLoads: builder.mutation<AllocatableLoad, Partial<AllocatableLoad>>({
      query: (allocatableLoads) => ({
        url: '/allocatable-loads',
        method: 'POST',
        body: allocatableLoads,
      }),
      invalidatesTags: () => {
        return [
          {type: 'AllocatableLoads', id: 'LIST'},
        ]
      }
    }),
    updateAllocatableLoads: builder.mutation<AllocatableLoad, Partial<AllocatableLoad>>({
      query: (allocatableLoads) => ({
        url: '/allocatable-loads',
        method: 'PUT',
        body: allocatableLoads,
      }),
      invalidatesTags: (result, error, {id}) => [{type: 'AllocatableLoads', id}],
    }),
    deleteAllocatableLoads: builder.mutation<void, string>({
      query: (id) => ({
        url: `/allocatable-loads/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, arg) => [{type: 'AllocatableLoads', arg}],
    }),
  }),
})

export const {
  useSearchAllocatableLoadsQuery,
  useGetAllAllocatableLoadsQuery,
  useGetAllocatableLoadsQuery,
  useCreateAllocatableLoadsMutation,
  useUpdateAllocatableLoadsMutation,
  useDeleteAllocatableLoadsMutation,
} = allocatableLoadsApi;
